(function () {
  'use strict';

  angular.module('app.performanceReportKPI')
    .factory('performanceReportKPIService', ['$q', '$http', '$rootScope', 
      function ($q, $http, $rootScope) {

        var service = {};

        function checkResponse(data) {
          return data;
        }

        function getMessage(data) {
          if (data) {
            return data.message;
          }
          return false;
        }

        function handleRequest(url) {
          var deferred = $q.defer(), result = 'requestFail';
          $http.get(url)
            .success(function (data) {
              var dataRes = angular.fromJson(data);

              if (checkResponse(dataRes)) {
                deferred.resolve(dataRes);
              } else {
                deferred.reject(getMessage(dataRes) || result);
              }
            })
            .error(function () {
              deferred.reject(result);
            });

          return deferred.promise;
        }

        function getMentionKPIData(params){
          var url = $rootScope.apiUrl + 'measure/getPerformanceGlobalKPIs?' + $.param(params);
          return handleRequest(url);
        }

        service.getMentionKPIData = getMentionKPIData;

        return service;
      }]);

})();
